/**
 * Componente de Layout
 * Estrutura principal com Navbar e Sidebar reutilizáveis
 * 
 * NOTA: O Dashboard agora gerencia sua própria Navbar e Sidebar.
 * Este Layout é mantido para compatibilidade com outras páginas.
 */

import React, { useState } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import { useAuth } from '../context/AuthContext';
import Navbar from './Navbar';
import Sidebar from './Sidebar';

/**
 * Componente de Layout principal
 */
const Layout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useAuth();

  // Páginas que gerenciam sua própria Navbar e Sidebar (como o Dashboard)
  const paginasComLayoutProprio = ['/dashboard'];
  const usaLayoutProprio = paginasComLayoutProprio.includes(location.pathname);

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  // Se a página gerencia seu próprio layout, renderiza apenas o Outlet
  if (usaLayoutProprio) {
    return <Outlet />;
  }

  // Para outras páginas, usa o layout padrão com Navbar e Sidebar
  return (
    <>
      <Navbar 
        onMenuToggle={() => setSidebarOpen(!sidebarOpen)} 
      />
      <Sidebar 
        open={sidebarOpen} 
        onClose={() => setSidebarOpen(false)} 
      />

      {/* Conteúdo principal */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          padding: '70px 30px 30px 30px',
          backgroundColor: 'background.default',
          minHeight: '100vh',
        }}
      >
        <Outlet />
      </Box>
    </>
  );
};

export default Layout;
